module.exports = {"API_URL":"https://4t6ozu3d4b.execute-api.ap-southeast-1.amazonaws.com/prod-my/v1/","SECRET_KEY":"secret"};